import { createContext, useContext, useSyncExternalStore } from 'react';
import type { AppStore } from '../state/store.js';
import type { AppState } from '../state/types.js';

const StoreContext = createContext<AppStore | null>(null);
export const StoreProvider = StoreContext.Provider;

/** The app store: actions go through it. */
export function useStore(): AppStore {
  const store = useContext(StoreContext);
  if (!store) throw new Error('The v1 UI needs its store provider.');
  return store;
}

/** The current app state; the component re-renders when it changes. */
export function useAppState(): AppState {
  const store = useStore();
  return useSyncExternalStore(store.subscribe, store.getState, store.getState);
}
